var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agreement-container" },
    [
      _vm.helpArticleInfo != null && _vm.helpArticleInfo.id != null
        ? [
            _c("div", { staticClass: "title" }, [
              _c("h4", [_vm._v(_vm._s(_vm.helpArticleInfo.title))]),
              _vm._v(" "),
              _c("span", { staticClass: "date" }, [
                _vm._v(
                  "主题：" +
                    _vm._s(_vm.helpSubjectMap[_vm.helpArticleInfo.subject]) +
                    "     时间：" +
                    _vm._s(_vm.helpArticleInfo.ts)
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content",
                domProps: { innerHTML: _vm._s(_vm.helpArticleInfo.content) }
              },
              [_c("span")]
            )
          ]
        : [
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "30px" } },
              [_vm._v("暂无帮助文章信息")]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7875eeda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7875eeda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/HelpArticleInfoShow.vue
// module id = 2205
// module chunks = 0